import React from 'react';
import { Award } from 'lucide-react';
import { CollapsibleSection } from './IntelligenceUIComponents';

const ScenarioRow = ({ scenario }) => (
  <tr className="border-b border-border/50 hover:bg-muted/20">
    <td className="p-3 font-medium">{scenario.outcome}</td>
    <td className="p-3 text-center">{scenario.probability ? `${scenario.probability}%` : '-'}</td>
    <td className="p-3 text-center">{scenario.coachVisibilityMultiplier}x</td>
    <td className="p-3 text-center">{scenario.mediaAmplificationIndex}</td>
    <td className={`p-3 text-center font-semibold ${scenario.brandValueImpact.includes('-') ? 'text-destructive' : 'text-stable'}`}>
      {scenario.brandValueImpact}
    </td>
    <td className={`p-3 text-center font-bold ${scenario.coachBrandChange < 0 ? 'text-destructive' : 'text-stable'}`}>
      {scenario.coachBrandChange > 0 ? '+' : ''}{scenario.coachBrandChange}
    </td>
  </tr>
);

export const TournamentSimulationSection = ({ data }) => {
  const scenarios = data?.tournamentSimulation?.scenarios || [];
  const expectedValue = data?.tournamentSimulation?.expectedValue || { weighted: 'N/A', confidence: 'N/A' };
  
  return (
    <CollapsibleSection title="Tournament Impact Simulation" icon={Award} defaultOpen={true} badge="2026 World Cup">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left p-3 text-xs text-muted-foreground uppercase">Outcome</th>
              <th className="text-center p-3 text-xs text-muted-foreground uppercase">Prob.</th>
              <th className="text-center p-3 text-xs text-muted-foreground uppercase">Visibility</th>
              <th className="text-center p-3 text-xs text-muted-foreground uppercase">Media</th>
              <th className="text-center p-3 text-xs text-muted-foreground uppercase">Impact</th>
              <th className="text-center p-3 text-xs text-muted-foreground uppercase">Δ Score</th>
            </tr>
          </thead>
          <tbody>
            {scenarios.map((s, i) => <ScenarioRow key={i} scenario={s} />)}
          </tbody>
        </table>
      </div>
      <div className="mt-4 p-4 bg-primary/5 rounded-lg border border-primary/20">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Expected Value</span>
          <div className="text-right">
            <span className="text-xl font-bold text-stable">{expectedValue.weighted}</span>
            <span className="text-xs text-muted-foreground ml-2">({expectedValue.confidence})</span>
          </div>
        </div>
      </div>
    </CollapsibleSection>
  );
};

export default TournamentSimulationSection;
